import * as T from '../constants/types';
import { readCachedUserSettings } from '../utils/userSettings';

const initialState = {
    // Настройки читаются из кэша синхронно, до логина: панель должна отрисоваться
    // сразу в нужном виде, без промежуточного кадра со всеми группами
    userSettings: readCachedUserSettings(),
};

export const loggedUser = (state = initialState, { type, payload }) => {
    switch (type) {
        case T.REQUEST_LOGGED_USER_INFO + T.SUCCESS:
            return { ...state, ...payload };
        case T.SET_USER_SETTINGS:
            return { ...state, userSettings: payload };
        default:
            return state;
    }
};
